import $ from "jquery";

$(function() {
    $(".bl-faq").on("click", ".summary", function() {
        const $accitem = $(this).closest(".faqitem");
        const isexpanded = $accitem.hasClass("expanded");

        const $details = $accitem.find(".details");
        const animspeed = 200;

        if(!isexpanded) {
            $accitem.addClass("expanded");
            $details.slideDown(animspeed);    
        } else {
            $accitem.removeClass("expanded");
            $details.slideUp(animspeed);    
        }
    });
});